import InputDebounce from "@ui/inputs/InputDebounce";
import {IconButton, InputAdornment} from "@mui/material";
import {SearchIcon} from "@ui/icons/icons";
import InputCustom from "@ui/inputs/InputCustom";
import {FC, FocusEvent, MouseEvent} from "react";
import {SxType} from "@baseTypes/sx/sxTypes";
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from "react-i18next";

interface IProps {
    value: string,
    onChange: (value: string) => void,
    error?: boolean,
    errorMessage?: string,
    name?: string,
    fullWidth?: boolean,
    size?: 'small',
    label?: string,
    placeholder?: string,
    setPage?: (page: number) => void,
    multiline?: boolean,
    rows?: number,
    disabled?: boolean,
    hasDebounce?: boolean,
    sx?: SxType,
    showSearchIcon?: boolean,
    onClick?: (event: MouseEvent<HTMLDivElement>) => void
    onFocus?: (event: FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    autoFocus?: boolean
}

const InputSearch: FC<IProps> = ({
                                     value,
                                     onChange,
                                     error,
                                     errorMessage,
                                     name,
                                     fullWidth = true,
                                     size = 'small',
                                     label,
                                     setPage,
                                     multiline,
                                     rows,
                                     disabled,
                                     hasDebounce,
                                     sx,
                                     placeholder,
                                     showSearchIcon,
                                     onClick,
                                     onFocus,
                                     autoFocus,
                                 }) => {

    const {t} = useTranslation()
    
    const handleChange = (value: string) => {
        onChange(value)
        if (setPage) {
            setPage(1)
        }
    }

    const inputSearchSx = {
        padding: 0,
        '&:hover': {
            cursor: disabled ? 'default' : 'pointer'
        }
    }

    const onClear = () => {
        handleChange('')
    }
    if (hasDebounce) {
        return (
            <InputDebounce
                errorMessage={errorMessage}
                disabled={disabled}
                rows={rows}
                fullWidth={fullWidth}
                size={size}
                label={label || t('base.search')}
                initialValue={value}
                onChange={handleChange}
                error={error}
                name={name}
                multiline={multiline}
                sx={sx}
                placeholder={placeholder}
                onClick={onClick}
                onFocus={onFocus}
                InputProps={{
                    endAdornment: <InputAdornment position="end">
                        {value &&
                            <IconButton
                                disabled={disabled}
                                sx={inputSearchSx}
                                size={'small'}
                                edge="end"
                                onClick={onClear}
                            >
                                <CloseIcon/>
                            </IconButton>}

                        {(showSearchIcon) && !value && <IconButton
                            disabled={disabled}
                            sx={inputSearchSx}
                            edge="end"
                        >
                            <SearchIcon
                                disabled={disabled}
                            />
                        </IconButton>}
                    </InputAdornment>,
                }}

            />)
    }
    return (
        <InputCustom
            errorMessage={errorMessage}
            disabled={disabled}
            rows={rows}
            fullWidth={fullWidth}
            size={size}
            label={label}
            value={value}
            onChange={handleChange}
            error={error}
            name={name}
            multiline={multiline}
            sx={sx}
            placeholder={placeholder}
            onClick={onClick}
            onFocus={onFocus}
            autoFocus={autoFocus}
            InputProps={{
                endAdornment: <InputAdornment position="end">
                    {value &&
                        <IconButton
                            disabled={disabled}
                            sx={inputSearchSx}
                            onClick={onClear}
                            size={'small'}
                            edge="end">
                            <CloseIcon/>
                        </IconButton>
                    }
                    {(showSearchIcon) && !value && <IconButton
                        disabled={disabled}
                        sx={inputSearchSx}
                        edge="end"
                    >
                        <SearchIcon
                            disabled={disabled}
                        />
                    </IconButton>}
                </InputAdornment>,
            }}

        />
    )
}

export default InputSearch;